export default "__VITE_PUBLIC_ASSET__13a71c7d__"